import React from 'react';
import Form from 'antd/lib/form';
import 'antd/lib/form/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import { countries } from 'react-flag-icon-css/lib/static/enums';
var ListAthleteFilterCountryCode = function (props) { return (React.createElement(Form.Item, { label: React.createElement("strong", null, "Country"), colon: false },
    React.createElement(Select, { size: 'large', style: { display: 'block' }, allowClear: true, showSearch: true, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }, onChange: function (value) {
            props.setFilters({ filterCountryCode: value });
        } },
        React.createElement(Select.Option, { key: '', value: '' }, "- Not specified -"),
        countries && countries.map(function (c) { return (React.createElement(Select.Option, { key: c.code, value: c.code }, c.name)); })))); };
export default ListAthleteFilterCountryCode;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListAthletePage/ListAthleteFilterCountryCode.tsx
// module id = 1099
// module chunks = 0